import React, { Component, Fragment } from 'react';
import moment from 'moment';
import { Form, Input, Select, DatePicker, Progress } from 'antd';
import { refreshTime,requestErrorLog } from '@/common/util';
import { initHospitalDepts, getTypicalCasesBaseInfo, remoteHospitalList, GetApplyHospital } from '@/request/api';


const { Option } = Select;
class ReferralQueryFrom extends Component {
	constructor(props) {
		const settingData = JSON.parse(localStorage.getItem("settingValues")) //获取本地配置
		super(props);
		this.state = {
			// 开始日期-结束日期
			defaultSelectDate: {
				startDate: moment().startOf("day").subtract(settingData && (settingData.referralApplyTime - 1), "days"),
				endDate: moment().endOf(-1, "day"),
			},
			percent: 0,
			refreshTimeNum: 0,
			departmentList: [],//申请科室
			referralStatus: [],//转诊状态
			referralProcess: [],//转诊进程
			consulationList: [],//转诊医院
			applyOrConsult: window.location.search.split('key=')[1],//当前是接收端还是申请端
			applyHospitalList: [],
			hospitalDateTimeArr: window.location.search.split('key=')[1] === '9' ? ['申请转诊日期'] : ['创建日期', '申请转诊日期']
		}
	}

	componentDidMount() {
		this.props.onRef(this)
		this.allBasicData()//基础数据
		this.initHospitalDept()//申请医院
		this.initApplHospCode()//转诊医院
		let refreshTimeNum = refreshTime(this)
		this.GetApplyHospital();//申请医院列表
		this.setState({
			refreshTimeNum
		}, () => {
			this.refreshTimer = setInterval(() => refreshTime(this, this.props.queryReferralData), this.state.refreshTimeNum * 1000 * 60 / 200)
		})
	}

	componentWillUnmount() {
		clearInterval(this.refreshTimer)
	}

	allBasicData = () => { //获取字典数据
		getTypicalCasesBaseInfo().then((res) => {
			if (res && res.Status === 1) {
				const basicsdata = res.Result.basicsdata;
				for (var i = 0; i < basicsdata.length; i++) {
					if (basicsdata[i].name === "转诊状态") {
						const statusList = basicsdata[i].dt;
						this.setState({
							referralStatus: statusList,
						});
					}
					if (basicsdata[i].name === "转诊进程") {
						const status = basicsdata[i].dt;
						this.setState({
							referralProcess: status,
						});
					}
				}
			}else{
				requestErrorLog('', '患者转诊-获取字典数据报错', 0,true)
			}
		});
	}

	initApplHospCode() { //获取会诊医院列表
		const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
		let params = {
			"Type": "Remote",
			"hospital_Code": userInfo.HOSPITAL_CODE
		}
		remoteHospitalList(params).then((res) => {
			if (res && res.Status === 1) {
				const applyData = res.Result
				let consulationList = applyData.filter(item => item.CONSULTATION_HOSPITAL_CODE !== userInfo.HOSPITAL_CODE)
				this.setState({
					consulationList: consulationList
				})
			}else{
				requestErrorLog('', '患者转诊-获取会诊医院报错', 0,true)
			}
		})
	}

	initApplHospCodes() { //获取申请转诊医院列表
		const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
		let params = {
			"Type": "Remote",
			"hospital_Code": userInfo.HOSPITAL_CODE
		}
		remoteHospitalList(params).then((res) => {
			if (res && res.Status === 1) {
				const applyData = res.Result
				let consulationList = applyData.filter(item => item.CONSULTATION_HOSPITAL_CODE !== userInfo.HOSPITAL_CODE)
				this.setState({
					consulationList: consulationList.filter(item => item.IS_ENABLED === 1)
				})
			}else{
				requestErrorLog('', '患者转诊-获取申请转诊医院列表报错', 0,true)
			}
		})
	}
	initHospitalDept(e) { //申请科室 
		const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
		let Req_Hospital_code = e ? e : '';
		let Param = {
			Type: "Hospital_Dept", //申请科室
			hospital_Code: this.state.applyOrConsult === '9' ? Req_Hospital_code : userInfo.HOSPITAL_CODE,//如果是轉診接收端，需要傳所選的申請醫院code
		};
		initHospitalDepts(Param).then((res) => {
			if (res && res.Status === 1) {
				this.setState({
					departmentList: res.Result
				})
			}else{
				requestErrorLog('', '患者转诊-获取医院科室', 0,true)
			}
		});
	}
	GetApplyHospital() {//获取申请端医院列表
		const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
		let param = {
			Type: "GetApplyHospital",
			hospital_Code: userInfo.HOSPITAL_CODE,
		}
		GetApplyHospital(param).then((res) => {
			if (res && res.Status === 1) {
				this.setState({
					applyHospitalList: res.Result
				})
			}else{
				requestErrorLog('', '患者转诊-获取申请端医院列表报错', 0,true)
			}
		})
	}
	disabledDate(current) { //只能选择今天跟今天之前的日期
		return current > moment().subtract(0, 'day')
	}

	render() {
		const { getFieldDecorator } = this.props.form;
		const { departmentList, referralStatus, referralProcess, applyHospitalList, defaultSelectDate: { startDate, endDate }, consulationList, percent, applyOrConsult, hospitalDateTimeArr } = this.state
		return (
			<>
				<Form layout="inline" className="referralCommonCase" ref={this.referralFormRef}>
					<div>
						<Form.Item label="患者姓名">
							{getFieldDecorator("Name", { initialValue: "" })(<Input />)}
						</Form.Item>

						{
							// 接收端不需要转诊状态和转诊进程
							applyOrConsult === '9' ? null :
								<Fragment>
									{
										this.props.tabsKey === '1' ?
											<Form.Item label="转诊状态">
												{getFieldDecorator("Referral_Status", { initialValue: "" })(
													<Select >
														<Option value="">全部</Option>
														{referralStatus.map((item) => (
															(item.DIC_NAME === "已转诊") ? null :
																<Option key={item.DIC_CODE} value={item.DIC_CODE}>
																	{item.DIC_NAME}
																</Option>
														))}
													</Select>
												)}
											</Form.Item> : null
									}

									<Form.Item label="转诊进程">
										{getFieldDecorator("Referral_Process", { initialValue: "" })(
											<Select>
												<Option value="">全部</Option>
												{referralProcess.map((item) => (
													<Option key={item.DIC_CODE} value={item.DIC_CODE}>
														{item.DIC_NAME}
													</Option>
												))}
											</Select>
										)}
									</Form.Item>
								</Fragment>
						}
						<Form.Item label="转诊编号">
							{getFieldDecorator("Referral_Uid", { initialValue: "" })(<Input />)}
						</Form.Item>
					</div>
					<div>
						{
							applyOrConsult === '9' ? <Form.Item label="申请医院">
								{getFieldDecorator("Req_Hospital_code", { initialValue: "" })(
									<Select placeholder="请选择申请转诊医院" onChange={(e) => { this.initHospitalDept(e) }}>
										<Option value="">全部</Option>
										{applyHospitalList.map((item) => (
											<Option key={item.HOSPITAL_PRIVILEGE_UID} value={item.APPLY_HOSPITAL_CODE}>
												{item.APPLY_HOSPITAL_NAME}
											</Option>
										))}
									</Select>
								)}
							</Form.Item> : null
						}
						<Form.Item label="申请科室">
							{getFieldDecorator("Req_Dept_Code", { initialValue: "" })(
								<Select placeholder="请选择申请科室">
									<Option value="">全部</Option>
									{departmentList.map((item) => (
										<Option key={item.DEPT_CODE} value={item.DEPT_CODE}>
											{item.DEPT_NAME}
										</Option>
									))}
								</Select>
							)}
						</Form.Item>
						{
							applyOrConsult === '9' ? null : <Form.Item label="转诊医院">
								{getFieldDecorator("Referral_Hospital_code", { initialValue: "" })(
									<Select placeholder="请选择会诊医院">
										<Option value="">全部</Option>
										{consulationList.map((item) => (
											<Option key={item.CONSULTATION_HOSPITAL_CODE} value={item.CONSULTATION_HOSPITAL_CODE}>
												{item.CONSULTATION_HOSPITAL_NAME}
											</Option>
										))}
									</Select>
								)}
							</Form.Item>
						}
						<Form.Item
							label={getFieldDecorator("hospitalDateTime", { initialValue: applyOrConsult === '9' ? "申请转诊日期" : "创建日期" })(
								<Select >
									{
										hospitalDateTimeArr.map((item, index) => {
											return (<Option value={item} key={item + index}>{item}:</Option>)
										})
									}
								</Select>
							)}
							className="mark dateTime"
						>
							{/* {getFieldDecorator("hospitalItemDateTime", {
								initialValue: [startDate, endDate],
							})(
								<RangePicker allowClear={false} disabledDate={this.disabledDate} />
							)} */}
							{getFieldDecorator('startTime', { initialValue: startDate })(
								<DatePicker
									style={{ width: 125 }}
									allowClear={false}
									placeholder='开始日期'
									disabledDate={this.disabledDate}
								/>)}
							<span style={{ display: 'inline-block', textAlign: 'center', width: 15 }}>-</span>
							<Form.Item style={{ width: 110 }}>
								{getFieldDecorator('endTime', { initialValue: endDate })(
									<DatePicker
										style={{ width: 125 }}
										allowClear={false}
										placeholder='结束日期'
										disabledDate={this.disabledDate}
									/>)}
							</Form.Item>
						</Form.Item>
						<Form.Item>
							<Progress className="progress" type="circle" strokeColor="#009d96" width={80} percent={percent} format={(percent) => "自动刷新"} />
						</Form.Item>
						{/* <Form.Item className="btn">
                                          <Button style={{ marginRight: '10px' }} onClick={this.queryReferralData}>查询</Button>
                                          <Button onClick={this.handleChangeReset}>重置</Button>
                                    </Form.Item> */}
					</div>
				</Form>
			</>
		)
	}
}

export default Form.create()(ReferralQueryFrom);
